import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetCostCentersWithoutFilter } from '../../../../../../queries';
import {
  ControlledCheckboxAutoComplete,
  ControlledSelect
} from '../../../../../shared';
import ValidFromAndToSection from './ValidFromAndToSection';
import { Box } from '@mui/material';
import { onRemoveElement } from '../utils/onRemoveElement';

const CapplanSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control, setValue, watch } = useFormContext();
  const { data: customerCostCenter } = useGetCostCentersWithoutFilter();

  const monthOrWeek = [
    { value: 'month', label: t('month') },
    { value: 'week', label: t('week') }
  ];

  return (
    <>
      <ValidFromAndToSection />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="month_or_week"
        label={t('monthOrWeek')}
        options={monthOrWeek}
      />
      <Box>
        <ControlledCheckboxAutoComplete
          fullWidth
          name={'br_id_list'}
          label={t('customerCostCenter')}
          variant="outlined"
          options={customerCostCenter ?? []}
          control={control}
          idProperty="brId"
          labelProperty="name"
          allowItemRemoval
          onRemoveElement={(id) =>
            onRemoveElement(setValue, watch, 'br_id_list', id)
          }
        />
      </Box>
    </>
  );
};

export default CapplanSection;
